// Map API endpoints here

export default $axios => ({
  getPoints({ partnerUser, params = {} }) {
    return $axios.get(`/api/partnerUser/${partnerUser}/points/current`, {
      params
    });
  }
});
